export default {
  dirty: state => state.dirty,
  saving: state => state.saving,
  inserting: state => state.inserting,
  total: state => state.total,
  loading: state => state.loading,
  showingUnsavedDialog: state => state.showingUnsavedDialog,
  title: state => state.title,
  subtitle: state => state.subtitle,
  managerId: (state, getters, rootState) => rootState.route.query.managerId,
  errors: state => state.errors,
  switchingToReadOnlyMode: state => state.switchingToReadOnlyMode,
  columnHeaderMetaData: state => state.columnHeaderMetaData,
  canInsert: state => state.canInsert,
  columns: state => state.columns,
  editing: state => state.currentlyEditingCells.length !== 0,
  currentlyEditingCells: state => state.currentlyEditingCells,
  selectedRange: state => state.selectedRange,
  refreshingMetadata: state => state.refreshingMetadata,
  refreshing: state => state.refreshing,
  count: state => state.count,
  mode: state => state.mode
}
